import {Injectable} from '@angular/core';
import {Observable} from 'rxjs-compat';
import {RegistrationExpressService} from '../../networking/services/registration-express/registration-express.service';
import {iDataUserRegistrationExpress, iDocumentTypesResponse, iRegistrationExpressCodeResponse, iRegistrationExpressValidateCode} from '../../networking/models/registration-express/registration-express';

@Injectable({
  providedIn: 'root',
})
export class RegistrationExpressMg {

  constructor(private services: RegistrationExpressService) { }

  validateCode(data: iRegistrationExpressValidateCode):Observable<iRegistrationExpressCodeResponse> {
    return this.services.validateCode(data);
  }

  saveUserExpress(data: iDataUserRegistrationExpress):Observable<iRegistrationExpressCodeResponse> {
    return this.services.saveUserExpress(data);
  }

  documentTypes(): Observable<iDocumentTypesResponse[]> {
    return this.services.documentTypes();
  }

}
